import { FILTER_TYPES } from "../../../../../../utils/filter";

const filterSalesWithDebit = (sales: Array<any>): Array<Object> =>
  sales.filter((sale) => sale.inDebit > 0);

const filterConfig = [
  {
    placeholder: "Type the name of the customer",
    type: FILTER_TYPES.TEXT,
    filterTitle: "Customer Name",
    dataField: "fullName",
  },
   {
    placeholder: "Type the email of the customer",
    type: FILTER_TYPES.TEXT,
    filterTitle: "Email",
    dataField: "email",
  },
];

export default filterConfig;
